/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { ManageReservationGuestAccessPayload } from 'api/actions/manage-reservation-guest-access/manage-reservation-guest-access-payload';
import { ManageReservationGuestAccessPathParameters } from 'api/actions/manage-reservation-guest-access/manage-reservation-guest-access-path-parameters';
import { ManageReservationGuestAccessResponse } from 'api/actions/manage-reservation-guest-access/manage-reservation-guest-access-response';

type ManageReservationGuestAccessQueryParameters = Record<string, any>;

/**
 * The path of the ManageReservationGuestAccess action.
 */
export const manageReservationGuestAccessActionPath = new SweetPath<keyof ManageReservationGuestAccessPathParameters>(
  '/admin/custom/reservations/{reservationId}/guest-access',
  { path: '{param}' }
);

/**
 * Creates a contextualized ManageReservationGuestAccess actions.
 */
export default function createManageReservationGuestAccessAction(axios: AxiosInstance) {
  return function manageReservationGuestAccessAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: ManageReservationGuestAccessPathParameters;
    query?: ManageReservationGuestAccessQueryParameters;
    payload: ManageReservationGuestAccessPayload;
  }) {
    const path = manageReservationGuestAccessActionPath.insert(parameters);

    return axios.post<
      ManageReservationGuestAccessResponse,
      ManageReservationGuestAccessResponse,
      ManageReservationGuestAccessPayload
    >(path, payload);
  };
}
